import styled from "@emotion/styled";

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${p => p.theme.space[2]}px;
`;
